// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoPlayer_videoWrapper__15NcF"};